import { Controller } from '@hotwired/stimulus'

const nprogress = () => (window as any).NProgress

export default class extends Controller {
  static targets = ['sourceElectionId', 'submitButton', 'statusMessageOutput', 'incompatibleElectionsDiv']

  declare sourceElectionIdTarget: HTMLInputElement
  declare submitButtonTarget: HTMLButtonElement
  declare statusMessageOutputTarget: HTMLElement
  declare incompatibleElectionsDivTarget: HTMLElement

  connect() {
    this.verifyInProgressCopyVoters();
  }

  switchAllSelections(event) {
    const checked = event.target.checked
    let targetElections = this.#getAllCheckboxes()

    targetElections.forEach((checkbox) => { checkbox.checked = checked })
    this.changeSubmitButtonDisableAttribute(!checked)
  }

  switchCheckbox(_event) {
    let targetElections = this.#getAllCheckboxes()

    let someChecked = targetElections.some((checkbox) => { return checkbox.checked })
    this.changeSubmitButtonDisableAttribute(!someChecked)
  }

  submit(event) {
    event.preventDefault()
    let targetElectionsIds = this.getAllSelectedTargetElectionsIds()
    Rails.ajax({
      type: 'post',
      url: `/elections/${this.sourceElectionId}/voter_list/copy/copies`,
      data: new URLSearchParams(targetElectionsIds.map(id => ['target_election_ids[]', id])).toString(),
      success: (_response) => { this.initCopyVotersStatusCheck() },
      error: (_response) => { this.#showFailureMessage() }
    })
  }

  get sourceElectionId() {
    return this.sourceElectionIdTarget.value;
  }

  set processingStatusMessageClass(className) {
    return this.statusMessageOutputTarget.className = className
  }

  set processingStatusMessageText(text) {
    return this.statusMessageOutputTarget.textContent = text
  }

  #getAllCheckboxes() {
    return [...document.querySelectorAll('#copy-voter-list-page-component table tbody input[type="checkbox"]')]
  }

  changeSubmitButtonDisableAttribute(disabledValue) {
    this.submitButtonTarget.disabled = disabledValue
  }

  getAllSelectedTargetElectionsIds() {
    return this.#getAllCheckboxes().filter(checkbox => checkbox.checked ).map(checkebox => checkebox.value)
  }

  scheduleCopyVotersStatusCheck() {
    Rails.ajax({
      type: 'get',
      url: `/elections/${this.sourceElectionId}/voter_list/copy/copies/status`,
      success: (processingStatus) => {
        let processingDone = processingStatus && processingStatus.done || false
        if (processingDone) {
          this.#showProcessingStatusMessage(processingStatus)
          this.#stopProgress()
        } else {
          setTimeout(() => { this.scheduleCopyVotersStatusCheck() }, 500)
        }
      },
      error: (_response) => {
        this.#stopProgress()
        this.#showFailureMessage()
      }
    })
  }

  #showProcessingStatusMessage(processingStatus) {
    if (processingStatus.error) {
      this.#showFailureMessage()
    } else {
      this.processingStatusMessageClass = 'message message--success'
      this.processingStatusMessageText = 'Copy completed!'
    }
  }

  #showFailureMessage() {
    this.processingStatusMessageClass = 'message message--error'
    this.processingStatusMessageText = 'Copy Failed.'
  }

  verifyInProgressCopyVoters(){
    Rails.ajax({
      type: 'get',
      url: `/elections/${this.sourceElectionId}/voter_list/copy/copies/status`,
      success: (processingStatus) => {
        if (Object.entries(processingStatus).length === 0) return;
        if (processingStatus && !processingStatus.done) {
          this.initCopyVotersStatusCheck();
        }
      },
    })
  }

  initCopyVotersStatusCheck() {
    this.#startProgress()
    this.processingStatusMessageClass = 'message';
    this.processingStatusMessageText = '';
    this.scheduleCopyVotersStatusCheck();
  }

  // Render inside the modal so the spinner sits above the modal blocker. The
  // `parent` setting is global, so restore it once done or every later
  // NProgress.start() on the page would target this (possibly removed) element.
  #startProgress() {
    nprogress()?.configure({ parent: '#copy-voter-list-page-component' })
    nprogress()?.start()
  }

  #stopProgress() {
    nprogress()?.done()
    nprogress()?.configure({ parent: 'body' })
  }

  toggleIncompatibleElections(event: Event) {
    const wasHidden = this.incompatibleElectionsDivTarget.classList.toggle('hide')
    const eventTarget = event.target as HTMLAnchorElement
    eventTarget.textContent = wasHidden ? 'view details' : 'hide details'
  }
}

